module.exports = __webpack_public_path__ + "static/media/icon-estoque-ajuste.f82ce11a.png";